import { render, staticRenderFns } from "./CreateChatbot.vue?vue&type=template&id=10d6091a&scoped=true"
import script from "./CreateChatbot.vue?vue&type=script&lang=js"
export * from "./CreateChatbot.vue?vue&type=script&lang=js"
import style0 from "./CreateChatbot.vue?vue&type=style&index=0&id=10d6091a&prod&scoped=true&lang=scss"
import style1 from "./CreateChatbot.vue?vue&type=style&index=1&id=10d6091a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6091a",
  null
  
)

export default component.exports